let zIndex = 5000
const openModals = {}
const onOpenStarts = {}
const onCloseStarts = {}

// This API is intended to be used in conjunction with the `Modal` vue component
export default function modal (id, options) {
  if (typeof window === 'undefined') {
    return
  }

  const publicAPI = {
    rootNode,
    open,
    close,
    isOpen,
  }

  if (typeof id === 'object') {
    if (id.isOpen === 'any') {
      return Object.values(openModals).some(m => !!m)
    }

    if (id.isOpen) {
      return !!openModals[id.isOpen]
    }

    console.error('Unknown command')

    return
  }

  if (!id) {
    console.error('A modal requires an id')

    return
  }

  options = options || {
    onOpenStart: null,
    onCloseStart: null,
  }

  if (typeof options.onOpenStart === 'function') {
    onOpenStarts[id] = options.onOpenStart
  }

  if (typeof options.onCloseStart === 'function') {
    onCloseStarts[id] = options.onCloseStart
  }

  function rootNode () {
    return document.getElementById(id)
  }

  function setScrollLock () {
    const openModals = document.querySelectorAll('.cms-modal--open')

    if (openModals.length) {
      document.documentElement.classList.add('cms-disable-scroll')
      document.body.classList.add('cms-disable-scroll')
    } else {
      document.documentElement.classList.remove('cms-disable-scroll')
      document.body.classList.remove('cms-disable-scroll')
    }
  }

  function open (options) {
    setTimeout(async () => {
      const modal = rootNode()

      if (!modal) {
        openModals[id] = false

        return
      }

      const modalContainer = modal.querySelector('.cms-modal__container')

      let open = true
      const onOpenStart = onOpenStarts[id]

      ++zIndex

      modalContainer.style.zIndex = zIndex

      ++zIndex

      modal.style.zIndex = zIndex

      if (typeof onOpenStart === 'function') {
        open = await onOpenStart(options)

        if (open === undefined) {
          open = true
        }
      }

      if (open) {
        modal.classList.add('cms-modal--open')
        openModals[id] = true
      }

      setScrollLock()
    }, 50)
  }

  function close () {
    setTimeout(async () => {
      const modal = rootNode()

      if (!modal) {
        document.documentElement.classList.remove('cms-disable-scroll')
        document.body.classList.remove('cms-disable-scroll')
        openModals[id] = false

        return
      }

      let close = true
      const onCloseStart = onCloseStarts[id]

      if (typeof onCloseStart === 'function') {
        close = await onCloseStart()

        if (close === undefined) {
          close = true
        }
      }

      if (close) {
        modal.classList.remove('cms-modal--open')
        openModals[id] = false
      }

      setScrollLock()
    }, 0)
  }

  function isOpen () {
    return openModals[id]
  }

  return publicAPI
}
